/*********************** Custom JS for Boost AI Search & Discovery  ************************/
const gridItemImageAdded = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            if (mutation.addedNodes.length && mutation.addedNodes[0].nodeName !== '#text' && mutation.addedNodes[0].classList.contains('boost-sd__product-image-img--main')) {
                let productCard = mutation.addedNodes[0].closest('.boost-sd__product-item')
                let isCanvas = productCard.querySelector('.boost-sd__product-title')
                    .textContent
                    .toLowerCase()
                    .includes('canvas')
                if (isCanvas) {
                    appendMockupImage(mutation.addedNodes[0])
                } else {
                    appendHiResImage(mutation.addedNodes[0])
                }

                observer.disconnect()
            }
        }
    }
};

const gridItemImages = (productCard) => {
    let isCanvas = productCard.querySelector('.boost-sd__product-title')
        .textContent
        .toLowerCase()
        .includes('canvas')
    if(productCard) {
        let imageNode = productCard.querySelector('.boost-sd__product-image-img--main');
        if(imageNode) {
            if (isCanvas) {
                appendMockupImage(imageNode)
            } else {
                appendHiResImage(imageNode)
            }
        }
    }

};

const handleBoostProductGrid = (mutationList, observer) => {
    let isWallCollection = document.body.classList.contains('collection-wallcovering')
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            if (mutation.addedNodes.length && mutation.addedNodes[0].nodeName !== '#text' && mutation.addedNodes[0].classList.contains('boost-sd-container')) {
                let targetEl = mutation.addedNodes[0]
                appendFilterOpen(targetEl)
                appendFilterClose(targetEl)

                let boostHeaderEl = targetEl.querySelector('.boost-sd__collection-header .boost-sd__header-description')
                let headerTitleEl = targetEl.querySelector('.boost-sd__collection-header .boost-sd__header-title')
                if (boostHeaderEl) {
                    let boostHeaderObserver = new MutationObserver(handleBoostHeader)
                    boostHeaderObserver.observe(boostHeaderEl, {
                        childList: true,
                        subtree: true
                    })
                }
                // updateHeaderTitle(headerTitleEl)
            }
            if (mutation.addedNodes.length && mutation.addedNodes[0].nodeName !== '#text' && mutation.addedNodes[0].classList.contains('boost-sd__pagination-infinite-scroll-container')) {
                let gridNode = mutation.addedNodes[0].querySelector('.boost-sd__product-list')
                let gridObserver = new MutationObserver(handleGridItems)
                let initialProductCards = document.querySelectorAll('.boost-sd__product-item')

                gridObserver.observe(gridNode, {
                    childList: true
                })
                boostObserver.disconnect()

                for (const productCard of initialProductCards) {

                    gridItemImages(productCard);

                    if (isWallCollection) {
                        appendColorwayCount(productCard);
                        //addColorParamLink(gridItem)
                    }

                }
            }
            if (mutation.target.id == 'boost-sd__filter-tree-wrapper') {
                let filterObserver = new MutationObserver(handleFilterItems)
                filterObserver.observe(mutation.target, {
                    childList: true,
                    subtree: true
                })
            }
        }
    }
};

const handleGridItems = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            if (mutation.addedNodes.length) {
                let gridItem = mutation.addedNodes[0]
                let isWallCollection = document.body.classList.contains('collection-wallcovering')
                if (isWallCollection) {
                    appendColorwayCount(gridItem)
                    //addColorParamLink(gridItem)
                }

                gridItemImages(gridItem);
            }
        }
    }
};

const appendMockupImage = (productImg) => {
    let html = ''
    let template = document.createElement('template')
    let imageContainer = productImg.closest('.boost-sd__product-image')
    let mainImageEl = imageContainer.querySelector('.boost-sd__product-image-img--main')
    let srcSetSizes = [200, 300, 400, 500, 600, 700, 800, 900, 1000, 1200, 1300, 1400, 1500, 1600]

    mainImageEl.classList.remove('boost-sd__product-image-img--main')
    mainImageEl.classList.add('boost-sd__product-image-img--second')

    for (let size of srcSetSizes) {

    }

    html = `<img class="boost-sd__product-image-img boost-sd__product-image-img--main" src="https://t0bvhcslmh.execute-api.us-east-1.amazonaws.com/Prod/limitless-photos/?frame=canvas2&style=style1&size=600&url=${productImg.src}" alt="${productImg.alt}" loading="eager">`
    template.innerHTML = html
    imageContainer.prepend(template.content)
};

const appendHiResImage = (productImg) => {
    productImg.srcset = productImg.srcset.split('1000w, ')[1]
};

const appendColorwayCount = (productCard) => {
    let productTitleEl = productCard.querySelector('.boost-sd__product-title')
    let productHandle = handleize(productTitleEl.textContent)
    let html = ''
    let template = document.createElement('template')
    let productData = collectionProductData[productHandle]

    if (productData && productData.variantCount) {
        html += `<div class="boost-sd__product-colorways">${productData.variantCount} colorways</div>`
        template.innerHTML = html
        productTitleEl.after(template.content)
    }
};

const addColorParamLink = (productCard) => {
    let productLinkEl = productCard.querySelector('.boost-sd__product-link')
    const urlParams = new URLSearchParams(window.location.search);
    const colorParam = urlParams.get('pf_opt_color');

    if (colorParam) {
        productLinkEl.href += `?pf_opt_color=${colorParam}`
    }
};

appendFilterOpen = (boostContainerEl) => {
    let html = ''
    let template = document.createElement('template')
    let filterColEl = boostContainerEl.querySelector('.boost-sd-left')
    let visuallyHidden = (!isMobile()) ? 'visually-hidden' : ''

    html += `<button class="boost-sd-filter-open">Filter`
    html += '<span class="boost-sd__filter-tree-toggle-button-icon">'
    html += '<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">'
    html += '<path fill-rule="evenodd" clip-rule="evenodd"'
    html += 'd="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z"'
    html += 'fill="white"></path>'
    html += '<mask id="mask0_8095:39389" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">'
    html += '<path fill-rule="evenodd" clip-rule="evenodd"'
    html += 'd="M0.8 3.2H3.348C3.6792 4.1288 4.5584 4.8 5.6 4.8C6.6416 4.8 7.5208 4.1288 7.852 3.2H15.2C15.6424 3.2 16 2.8424 16 2.4C16 1.9576 15.6424 1.6 15.2 1.6H7.852C7.5208 0.6712 6.6416 0 5.6 0C4.5584 0 3.6792 0.6712 3.348 1.6H0.8C0.3576 1.6 0 1.9576 0 2.4C0 2.8424 0.3576 3.2 0.8 3.2ZM15.2 12.8H7.852C7.5208 11.8712 6.6416 11.2 5.6 11.2C4.5584 11.2 3.6792 11.8712 3.348 12.8H0.8C0.3576 12.8 0 13.1576 0 13.6C0 14.0424 0.3576 14.4 0.8 14.4H3.348C3.6792 15.3288 4.5584 16 5.6 16C6.6416 16 7.5208 15.3288 7.852 14.4H15.2C15.6424 14.4 16 14.0424 16 13.6C16 13.1576 15.6424 12.8 15.2 12.8ZM15.2 7.2H12.652C12.3208 6.2712 11.4416 5.6 10.4 5.6C9.3584 5.6 8.4792 6.2712 8.148 7.2H0.8C0.3576 7.2 0 7.5576 0 8C0 8.4424 0.3576 8.8 0.8 8.8H8.148C8.4792 9.7288 9.3584 10.4 10.4 10.4C11.4416 10.4 12.3208 9.7288 12.652 8.8H15.2C15.6424 8.8 16 8.4424 16 8C16 7.5576 15.6424 7.2 15.2 7.2ZM5.6 1.6C6.0416 1.6 6.4 1.9584 6.4 2.4C6.4 2.8416 6.0416 3.2 5.6 3.2C5.1584 3.2 4.8 2.8416 4.8 2.4C4.8 1.9584 5.1584 1.6 5.6 1.6ZM5.6 14.4C5.1584 14.4 4.8 14.0416 4.8 13.6C4.8 13.1584 5.1584 12.8 5.6 12.8C6.0416 12.8 6.4 13.1584 6.4 13.6C6.4 14.0416 6.0416 14.4 5.6 14.4ZM10.4 8.8C9.9584 8.8 9.6 8.4416 9.6 8C9.6 7.5584 9.9584 7.2 10.4 7.2C10.8416 7.2 11.2 7.5584 11.2 8C11.2 8.4416 10.8416 8.8 10.4 8.8Z"'
    html += 'fill="white"></path>'
    html += '</mask>'
    html += '<g mask="url(#mask0_8095:39389)"></g>'
    html += '</svg>'
    html += '</span>'
    html += '</button>'

    let collectionHeaderEl = document.querySelector('.boost-sd__collection-header')
    template.innerHTML = html
    collectionHeaderEl.after(template.content)
    filterColEl.classList.add('visually-hidden')

    let filterOpenEl = boostContainerEl.querySelector('.boost-sd-filter-open')

    filterOpenEl.addEventListener('click', () => {
        if (isMobile()) {
            if (document.querySelector('.boost-sd__filter-tree-toggle-button')) {
                document.querySelector('.boost-sd__filter-tree-toggle-button').click()
            }
        } else {
            filterColEl.classList.remove('visually-hidden')
            filterOpenEl.classList.add('visually-hidden')
        }
    })
}

appendFilterClose = (boostContainerEl) => {
    let html = ''
    let template = document.createElement('template')
    let filterColEl = boostContainerEl.querySelector('.boost-sd-left')
    let filterOpenEl = boostContainerEl.querySelector('.boost-sd-filter-open')

    html += '<div class="boost-sd-filter-close">'
    html += '<h2 class="boost-sd-filter-close-title">Filter</h2>'
    html += '<button class="boost-sd-filter-close-btn h4">×</button>'
    html += '</div>'

    template.innerHTML = html
    filterColEl.prepend(template.content)

    let filterCloseEl = filterColEl.querySelector('.boost-sd-filter-close-btn')

    filterCloseEl.addEventListener('click', () => {
        filterColEl.classList.add('visually-hidden')
        filterOpenEl.classList.remove('visually-hidden')
    })
}

let handleFilterItems = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            if (mutation.addedNodes.length && mutation.addedNodes[0].nodeName !== '#text' && mutation.addedNodes[0].classList.contains('boost-sd__filter-tree-vertical-content')) {
                let collectionUrl = window.location.pathname
                let isMural = (collectionUrl.includes('mural')) ? true : false
                let isCanvas = (collectionUrl.includes('canvas')) ? true : false
                let filterLabelEls = mutation.addedNodes[0].querySelectorAll('.boost-sd__filter-option-item-label')

                filterLabelEls.forEach((label) => {
                    let labelText = label.innerText
                    let labelLink = label.closest('.boost-sd__filter-option-item-button')

                    if (isMural && labelText != "Wall Mural") {
                        label.innerText = labelText.replace('Wall Murals', '')
                        label.innerText = label.innerText.replace('Wall Mural', '')
                    }
                    if (isCanvas && (labelText != "Canvas Wrap" || labelText != "Canvas Wraps")) {
                        label.innerText = labelText.replace('Canvas Art', '')
                    }
                })
            }
        }
    }
}

const handleBoostSearch = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            if (mutation.addedNodes.length && mutation.addedNodes[0].nodeName !== '#text' && mutation.addedNodes[0].classList.contains('boost-sd__search-bar-wrapper')) {
                let boostSearchBar = document.querySelector('.boost-sd__search-bar-wrapper')
                let boostSearchClose = document.querySelector('.boost-sd__button-text-x ')
                boostSearchBar.addEventListener('click', (event) => {
                    if (event.target !== event.currentTarget) return

                    // boostSearchBar.classList.add('boost-sd__g-hide')
                    // document.body.classList.remove('lock-all')
                    boostSearchClose.click()
                })
                observer.disconnect();
            }
        }
    }
}

let handleBoostHeader = (mutationList, observer) => {
    for (const mutation of mutationList) {
        if (mutation.type === "childList") {
            updateHeaderTitle(mutation.target.parentElement.querySelector('.boost-sd__header-title'))
        }
    }
}

let updateHeaderTitle = (headerTitleEl) => {
    let collectionName = headerTitleEl.innerText
    let isMural = (collectionName == 'Murals' || collectionName.includes('Wall Mural')) ? true : false
    let isCanvas = (collectionName.includes('Canvas Art') || collectionName.includes('Canvas Wrap')) ? true : false

    if (isMural) {
        headerTitleEl.innerText = headerTitleEl.innerText.replace('Wall Murals', '')
        headerTitleEl.innerText = headerTitleEl.innerText.replace('Wall Mural', '')
    }
    if (isCanvas) {
        headerTitleEl.innerText = headerTitleEl.innerText.replace('Canvas Art', '')
    }
}

const boostObserver = new MutationObserver(handleBoostProductGrid)
let boostNode = document.querySelector('.boost-sd__product-filter-fallback')
if (boostNode) {
    boostObserver.observe(boostNode, {
        childList: true,
        subtree: true
    })
}

const boostSearchObserver = new MutationObserver(handleBoostSearch)
boostSearchObserver.observe(document.body, {
    childList: true,
    subtree: true
})

isMobile = () => {
    return (window.innerWidth < 768) ? true : false
}

handleize = (str) => {
    str = str.toLowerCase()
    let toReplace = ['"', "'", "\\", "(", ")", "[", "]"]

    for (var i = 0; i < toReplace.length; ++i) {
        str = str.replace(toReplace[i], "")
    }

    str = str.replace(/\W+/g, "-")

    if (str.charAt(str.length - 1) == "-") {
        str = str.replace(/-+\z/, "")
    }

    if (str.charAt(0) == "-") {
        str = str.replace(/\A-+/, "")
    }

    return str
}

let searchToggles = document.querySelectorAll('[aria-controls="search-drawer"]')

searchToggles.forEach((searchToggle) => {
    searchToggle.addEventListener('click', () => {
        let boostSearchBar = document.querySelector('.boost-sd__search-bar-wrapper')
        let boostSearchBarInput = document.querySelector('.boost-sd__search-bar-input')
        boostSearchBar.classList.remove('boost-sd__g-hide')
        boostSearchBarInput.focus()
    })
})
